import {Button} from "antd";

export const CustomButton = ({  children, style, ...props }) => {
    return (
        <Button {...props} style={{ height: '5vh', width: '12vw', fontSize: '1.2vw', borderRadius: '8px', paddingTop: 0,...style }}>{ children }</Button>
    )
}
